export class AdditionalData {
      id:any;
      name:any;
      email:any;
      dob:any;
      mobile:any; 
      sex:any; 
      address:any; 
      distId:any; 
      pin:any; 
      designationId:any; 
      departmentId:any;
      categoryId:any; 
      phid:any; 
     // advno:any; 
      publjrnlno:any; 
      publbooksno:any; 
      publprocedingno:any; 
      attndseminerno:any; 
      attndconfno:any; 
      attndworkshopno:any; 
      phdguideno:any;
      researchprojno:any; 
      apiscore:any; 
      applicationNo:any; 
      subjectsplid:any;
      userid:any;
      postcategoryid:any;
      advid:any;
      academicData: {
        academicyr: any,
        edudetail: any;
        exampass: any;
        id: any;
        parent_id: any;
        marks: any;
        subjectstudied: any;
        otherinfo: any;
        division:any;
    }[]; 
      experienceData: {
        id: any;
        parent_id: any;
        fromdate: any;
        todate: any;
        instituteName: any;
        yearcount: any;
        typeofemployee:any;
        monthcount:any;
    }[];

}


// WEBPACK FOOTER //
// ./src/app/staffrecruitment/AdditionalData.ts